((doc) => {
  const STATE_CHANGE_EVENT = 'SVWebAppCaptchaStateChanged';

  const getNormalizedState = (state) => {
    if (state === 'completed') {
      return 'verified';
    }

    if (state === 'expired') {
      return 'expired';
    }

    if (state === 'error' || state === 'destroyed') {
      return 'error';
    }

    return 'pending';
  };

  const dispatchStateChange = (widget, state) => {
    if (widget.getAttribute('data-sv-captcha-state') === state) {
      return;
    }

    widget.setAttribute('data-sv-captcha-state', state);

    let event;
    if (typeof window.CustomEvent === 'function') {
      event = new CustomEvent(STATE_CHANGE_EVENT, { bubbles: true });
    } else {
      event = doc.createEvent('CustomEvent');
      event.initCustomEvent(STATE_CHANGE_EVENT, true, false, null);
    }
    widget.dispatchEvent(event);
  };

  const setup = () => {
    const friendlyCaptchaV1Elements = doc.querySelector(
      '.frc-captcha:not([data-friendly-captcha-v2])',
    );
    const friendlyCaptchaV2Elements = doc.querySelectorAll(
      '.frc-captcha[data-friendly-captcha-v2]',
    );

    if (friendlyCaptchaV1Elements) {
      import(/* webpackChunkName: "friendly-c" */ 'friendly-challenge/widget');
    }

    if (friendlyCaptchaV2Elements.length) {
      import(
        /* webpackChunkName: "friendly-c-v2" */ '@friendlycaptcha/sdk'
      ).then(({ FriendlyCaptchaSDK }) => {
        const sdk = new FriendlyCaptchaSDK();
        const elements = [];

        for (let i = 0; i < friendlyCaptchaV2Elements.length; i++) {
          elements[elements.length] = friendlyCaptchaV2Elements[i];
        }

        sdk.attach(elements);
      });
    }
  };

  if (doc.readyState !== 'loading') {
    setup();
  } else {
    doc.addEventListener('DOMContentLoaded', setup);
  }

  doc.addEventListener('frc:widget.statechange', (event) => {
    const widget = event.target;

    if (
      !widget ||
      widget.getAttribute('data-sv-captcha-provider') !== 'friendly'
    ) {
      return;
    }

    dispatchStateChange(widget, getNormalizedState(event.detail.state));
  });
  doc.addEventListener('SVInitCaptchaTrigger', setup);
})(document);
